import { z } from 'zod';

import { skillTypeSchema } from '~/shared/data-contract/skill';

export const requestSkillTitleMaxLength = 128;

export const requestSkillSchema = z.object({
    description: z.string(),
    title: z.string().max(requestSkillTitleMaxLength),
    type: skillTypeSchema.optional(),
});

export type RequestSkill = z.infer<typeof requestSkillSchema>;
